import React, { useRef, useState } from "react";
import containerIcon from "../../images/container.svg";
import brochureImg from "../../images/merkazy_brochure.png";
import beginner from "../../images/Osnovni.png";
import intermediate from "../../images/Sredno napredni.png";
import advanced from "../../images/Napredni.png";
import FormSection from "../../components/FormSection";

import thumb1 from "../../images/1.png";
import thumb2 from "../../images/2.png";
import thumb3 from "../../images/3.png";
import thumb4 from "../../images/4.png";
import thumb5 from "../../images/5.png";
import thumb6 from "../../images/6.png";
import thumb7 from "../../images/7.png";
import thumb8 from "../../images/8.png";
import thumb9 from "../../images/9.png";
import thumb10 from "../../images/10.png";
import thumb11 from "../../images/11.png";
import thumb12 from "../../images/12.png";
import thumb13 from "../../images/13.png";
import thumb14 from "../../images/14.png";
import thumb15 from "../../images/15.png";
import thumb16 from "../../images/16.png";
import thumb17 from "../../images/17.png";
import thumb18 from "../../images/18.png";
import thumb19 from "../../images/19.png";
import thumb20 from "../../images/20.png";
import thumb21 from "../../images/21.png";
import thumb22 from "../../images/22.png";
import thumb23 from "../../images/23.png";
import thumb24 from "../../images/24.png";
import thumb25 from "../../images/25.png";
import thumb26 from "../../images/26.png";
import thumb27 from "../../images/27.png";
import thumb28 from "../../images/28.png";
import thumb29 from "../../images/29.png";
import thumb30 from "../../images/30.png";
import thumb31 from "../../images/31.png";
import thumb32 from "../../images/32.png";
import thumb33 from "../../images/33.png";
import thumb34 from "../../images/34.png";
import thumb35 from "../../images/35.png";
import thumb36 from "../../images/36.png";
import thumb37 from "../../images/37.png";
import thumb38 from "../../images/38.png";
import thumb39 from "../../images/39.png";
import thumb40 from "../../images/40.png";
import thumb41 from "../../images/41.png";
import thumb42 from "../../images/42.png";
import thumb43 from "../../images/43.png";
import thumb44 from "../../images/44.png";
import thumb45 from "../../images/45.png";
import thumb46 from "../../images/46.png";

const thumbnails = [
  thumb1, thumb2, thumb3, thumb4, thumb5, thumb6, thumb7,
  thumb8, thumb9, thumb10, thumb11, thumb12, thumb13, thumb14,
  thumb15, thumb16, thumb17, thumb18, thumb19, thumb20, thumb21,
  thumb22, thumb23, thumb24, thumb25, thumb26, thumb27, thumb28,
  thumb29, thumb30, thumb31, thumb32, thumb33, thumb34, thumb35,
  thumb36, thumb37, thumb38, thumb39, thumb40, thumb41, thumb42,
  thumb43, thumb44, thumb45, thumb46
];

const Tutorials: React.FC = () => {
const tutorialRef = useRef<HTMLElement>(null);

  const scrollToTutorials = () => {
    if (tutorialRef.current) {
      const headerOffset = 80;
      const elementPosition =
        tutorialRef.current.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    }
  };

  const [playing, setPlaying] = useState<Record<string, boolean>>({});

  const videosBasic = [
    { id: "c2NhFxfc3iA", thumbnail: thumbnails[10], title: "Преглед" },    
    { id: "-hkQLj_nD_I", thumbnail: thumbnails[8], title: "Резервација од фиксен закуп" }, 
    { id: "GlCmLjTdQkE", thumbnail: thumbnails[3], title: "Доплата" }, 
    { id: "8UfMdSFyk10", thumbnail: thumbnails[2], title: "Уреди патници" }, 
    { id: "92v2ECnSTNQ", thumbnail: thumbnails[4], title: "Документи" }, 
    { id: "JHDM0YCKG9E", thumbnail: thumbnails[0], title: "Замрзни соба" },
    { id: "_8C6F-jh2ws", thumbnail: thumbnails[1], title: "Финансиски преглед" }, 
    { id: "R6TKwbHnFVs", thumbnail: thumbnails[9], title: "Уреди резервација" }, 
    { id: "MMeTdoZ4XTk", thumbnail: thumbnails[5], title: "Откажи резервација" }, 
    { id: "J9qy2Fjjv98", thumbnail: thumbnails[12], title: "Уреди резервација во слободна продажба" },
    { id: "-U9FIUGL9yw", thumbnail: thumbnails[6], title: "Откажи резервација во слободна продажба" },
    { id: "E9g4ooRwnuU", thumbnail: thumbnails[11], title: "Патна листа и листа на соби" },
  ];

  const videosIntermediate = [
    { id: "D3FlcIRAdZo", thumbnail: thumbnails[13], title: "Агенти" },
    { id: "ddKwlOXzNJ0", thumbnail: thumbnails[43], title: "Агенција" }, 
    { id: "OPHW3-778MQ", thumbnail: thumbnails[41], title: "Уредување аранжмани и цени" }, 
    { id: "e0MCTTqu2aY", thumbnail: thumbnails[32], title: "Темплејти за превоз" },    
    { id: "R-JUxnGvUbw", thumbnail: thumbnails[14], title: "Групен попуст" },
    { id: "7KY6VnR6AE4", thumbnail: thumbnails[15], title: "Продажба на осигурување" }, 
    { id: "NCM-m4Da4Qo", thumbnail: thumbnails[16], title: "Еднодневна екскурзија" },
    { id: "1238ljqHZiw", thumbnail: thumbnails[17], title: "Креирање темплејти" },
    { id: "DsoXyBQwQsk", thumbnail: thumbnails[19], title: "Цена по лице" },
    { id: "Wvt32Mp_nPQ", thumbnail: thumbnails[31], title: "Транспорт" }, 
    { id: "sUm7C4qa4HE", thumbnail: thumbnails[21], title: "Мрежа на субагенти" },
    { id: "2C6-chBRC7o", thumbnail: thumbnails[22], title: "Сместување и сместувачки единици" },
    { id: "gQkzKoGw62I", thumbnail: thumbnails[25], title: "Продажба на визи" }, 
  ];

  const videosAdvanced = [
    { id: "iLX7ip51J3o", thumbnail: thumbnails[45], title: "Статистика за продажба" },
    { id: "KrDwSbQplHw", thumbnail: thumbnails[44], title: "Електронски потпис" },
  ];

  const renderVideoCard = (video: { id: string; thumbnail: string; title: string }) => {
    const hasId = video.id && video.id.trim() !== "";
    const isPlaying = playing[video.id];

    return (
      <div key={video.title} className="rounded-3xl">
        {/* Video with ID */}
        {hasId ? (
          <>
            {!isPlaying && (
              <div
                className="relative rounded-3xl overflow-hidden cursor-pointer"
                style={{ paddingBottom: "56.25%" }}
                onClick={() => setPlaying(p => ({ ...p, [video.id]: true }))}
              >
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="absolute top-0 left-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="bg-white/80 rounded-full p-4 group-hover:scale-110 transition text-black text-xl font-bold">
                    ▶
                  </div>
                </div>
              </div>
            )}

            {isPlaying && (
              <div
                className="relative rounded-3xl overflow-hidden"
                style={{ paddingBottom: "56.25%" }}
              >
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src={`https://www.youtube.com/embed/${video.id}?autoplay=1`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            )}
          </>
        ) : (
          // Placeholder (no ID)
          <div
            className="relative rounded-3xl overflow-hidden"
            style={{ paddingBottom: "56.25%" }}
          >
            <img
              src={video.thumbnail}
              alt={video.title}
              className="absolute top-0 left-0 w-full h-full object-cover"
            />
          </div>
        )}

        {/* Title */}
        <div className="mt-3 pl-1 text-left text-gray-900 font-semibold text-lg">
          {video.title}
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white">
      <section className="text-center pt-24 px-4 md:px-6">
        <div className="container mx-auto">
          <h1 className="text-4xl md:text-6xl font-semibold leading-tight mb-6">
            <span className="text-[#0c0407]">Merakzy </span>
            <span className="text-[#c4c4c4]">е новиот регионален</span>
            <span className="text-[#0c0407] block">
              <span className="text-[#c4c4c4]">стандард за</span> туристички агенции
            </span>
          </h1>
          <p className="text-lg md:text-xl text-[#0c0407] max-w-3xl mx-auto mt-4">
            Погледнете како преку еден софтвер можете да ги менаџирате сите <br/> понуди, резервации и цела комуникација со патниците и субагентите.
          </p>
          <button
            onClick={scrollToTutorials}
            className="mt-8 flex items-center justify-center gap-2 bg-[#fa0053] text-white font-bold rounded-full px-6 py-3 mx-auto hover:opacity-90 transition"
          >
            Видете ги туторијалите 
            <img src={containerIcon} alt="" className="w-5 h-5" />
          </button>
        </div>
      </section>

      <section className="relative w-full pb-12 md:pb-16 px-4 md:px-6">
        <div className="container mx-auto">
          <div className="relative w-full h-[20rem] md:h-[50rem] rounded-3xl overflow-hidden">
            <img
              src={brochureImg}
              alt="Brochure"
              className="w-full h-full object-contain rounded-3xl"
            />
          </div>
        </div>
      </section>

      {/* BASIC Section */}
      <section className="bg-white pb-24 px-4 md:px-6"  ref={tutorialRef}>
        <div className="container mx-auto">
          <div className="text-left md:text-center mb-12"> 
            <div className="flex items-center md:justify-center gap-2 mb-6"> 
              <div className="w-6 h-6 flex items-center justify-center rounded-full"> 
                <img src={beginner} alt="" className="w-6 h-6" /> 
              </div> 
              <span className="font-semibold text-sm">ОСНОВНО НИВО</span> 
            </div> 
            <h2 className="text-3xl md:text-5xl font-semibold mb-6"> Основни туторијали</h2> 
            <p className="text-lg md:text-xl text-gray-800"> 
              Овие кратки туторијали ќе ве запознаат со основните фукнционалности на софтверот и ќе <br /> 
              ви помогнат побрзо да научите како правилно се користи Merakzy.
            </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {videosBasic.map(renderVideoCard)}
          </div>
        </div>

        {/* INTERMEDIATE Section */}
        <div className="container mx-auto mt-20">
          <div className="text-left md:text-center mb-12"> 
            <div className="flex items-center md:justify-center gap-2 mb-6"> 
              <div className="w-6 h-6 flex items-center justify-center rounded-full"> 
                <img src={intermediate} alt="" className="w-6 h-6" /> 
              </div> 
              <span className="font-semibold text-sm">СРЕДНО НАПРЕДНО НИВО</span> 
            </div> 
            <h2 className="text-3xl md:text-5xl font-semibold mb-6">Средно напредни туторијали</h2> 
            <p className="text-lg md:text-xl text-gray-800"> 
              Овие туторијали се наменети за туристички агенции кои веќе работат во Merakzy и <br /> 
              сакаат да дознаат нови можности за подобра продажба и организација.
            </p>            
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {videosIntermediate.map(renderVideoCard)}
          </div>
        </div>

        {/* ADVANCED Section */}
        <div className="container mx-auto mt-20">
          <div className="text-left md:text-center mb-12"> 
            <div className="flex items-center md:justify-center gap-2 mb-6"> 
              <div className="w-6 h-6 flex items-center justify-center  rounded-full"> 
                <img src={advanced} alt="" className="w-6 h-6" /> 
              </div> 
              <span className="font-semibold text-sm">НАПРЕДНО НИВО</span> 
            </div> 
            <h2 className="text-3xl md:text-5xl font-semibold mb-6"> Напредни туторијали</h2> 
            <p className="text-lg md:text-xl text-gray-800"> 
              Овде се најдеталните туторијали за оптимизација на секој дел од продажниот процес кој<br /> 
              ќе ви помогне целосно да работите дигитално со помош на Merakzy.              
            </p>             
            </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {videosAdvanced.map(renderVideoCard)}
          </div>
        </div>
      </section>

      <FormSection />

      <div className="bg-[#f8f8f8] w-full">
        <div className="border-t border-gray-300 mx-auto container"></div>
      </div>
    </div>
  );
};

export default Tutorials;